<template>
  <div>
    <vx-card class="mb-4">
      <h4 class="mb-1">{{ $t('influencer_group.title') }}</h4>
      <small class="text-muted d-block mb-3">{{ $t('influencer_group.hint') }}</small>

      <div class="vx-row">
        <div class="vx-col sm:w-6/12 w-full">
          <b-form-group :label="$t('influencer_group.name')" label-for="name">
            <b-form-input id="name" v-model="model.name" type="text" class="required"/>
          </b-form-group>
        </div>
        <div class="vx-col sm:w-6/12 w-full">
          <b-form-group :label="$t('influencer_group.status')" label-for="status">
            <b-form-radio-group id="status" v-model="model.status" :options="statusList"/>
          </b-form-group>
        </div>
      </div>

      <b-form-group :label="$t('influencer_group.description')" label-for="description">
        <b-form-textarea id="description" v-model="model.description" rows="2"/>
      </b-form-group>

      <b-form-group v-if="isEdit" :label="$t('influencer_group.members')" label-for="members">
        <v-select
          id="members"
          v-model="model.influencer_ids"
          :options="influencers"
          :reduce="opt => opt.id"
          label="name"
          multiple
          class="w-full">
          <div slot="no-options">{{ $t('influencer_group.no_influencers') }}</div>
        </v-select>
        <small class="text-muted">{{ $t('influencer_group.members_hint') }}</small>
      </b-form-group>
      <b-alert v-else variant="primary" show class="p-1 mb-0">
        <small>{{ $t('influencer_group.members_after_save') }}</small>
      </b-alert>

      <b-form-row class="justify-end mt-2">
        <b-col cols="auto">
          <b-button variant="primary" @click="createOrUpdate">{{ $t('save') }}</b-button>
        </b-col>
        <b-col cols="auto">
          <b-button variant="outline-secondary" @click="goBack">
            <feather-icon icon="CornerUpLeftIcon" class="mr-50"/>
            <span class="align-middle">{{ $t('back') }}</span>
          </b-button>
        </b-col>
      </b-form-row>
    </vx-card>
  </div>
</template>

<script>
import {
  BFormGroup, BFormInput, BFormTextarea, BFormRadioGroup,
  BButton, BFormRow, BCol, BAlert
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import InfluencerGroupService from '@/services/api/InfluencerGroupService'
import InfluencerService from '@/services/api/InfluencerService'

export default {
  components: {
    BFormGroup, BFormInput, BFormTextarea, BFormRadioGroup,
    BButton, BFormRow, BCol, BAlert, vSelect
  },
  props: {
    id: { type: [Number, String], default: null }
  },
  data: () => ({
    service: null,
    influencerService: null,
    influencers: [],
    model: {
      id: null,
      name: '',
      description: '',
      status: 'AC',
      influencer_ids: []
    },
    statusList: [
      { text: 'Ativo', value: 'AC' },
      { text: 'Inativo', value: 'IN' }
    ]
  }),
  computed: {
    isEdit() {
      return !_.isNil(this.id)
    }
  },
  methods: {
    loadInfluencers() {
      this.influencerService.all().then(list => { this.influencers = list || [] }, () => {})
    },
    loadData(id) {
      this.$vs.loading()
      this.service.read(id).then(
        response => {
          this.model.id = response.id
          this.model.name = response.name
          this.model.description = response.description
          this.model.status = response.status
          this.model.influencer_ids = (response.influencers || []).map(i => i.id)
        },
        () => { this.$vs.loading.close() }
      ).finally(() => { this.$vs.loading.close() })
    },
    createOrUpdate() {
      this.$vs.loading()
      this.service.createOrUpdate({
        id: this.id,
        name: this.model.name,
        description: this.model.description,
        status: this.model.status
      }).then(
        data => {
          // Membros têm endpoint próprio (é coleção, não campo) e só existem
          // depois que o grupo tem id.
          const after = this.isEdit
            ? this.service.saveMembers(this.id, this.model.influencer_ids)
            : Promise.resolve()

          return after.then(() => {
            this.notifySuccess(this.$vs, this.$t('messages.success'))
            if (!this.isEdit) this.$router.push(`/influencer_groups/${data.id}/edit`)
          })
        },
        error => this.showErrors(this.$validator, error, this)
      ).finally(() => { this.$vs.loading.close() })
    },
    goBack() {
      this.$router.push('/influencer_groups')
    }
  },
  beforeMount() {
    this.service = InfluencerGroupService.build(this.$vs)
    this.influencerService = InfluencerService.build(this.$vs)
  },
  mounted() {
    this.loadInfluencers()
    if (this.id) this.loadData(this.id)
  }
}
</script>
